import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FormFractioning from './components/FormFractioning';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import Help from '../../generics/help';

var Config = require('../../../config');

class Factioning extends Component{
	constructor(props){
		super(props);

		this.onSave = this.onSave.bind(this);
		this.onReturn = this.onReturn.bind(this);
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
	}

	onSave(){
		if (this.isValidDate(this.form.state.date_form)){
		  if (this.isValidForm()) {
			var division_parts = this.form.getValues();
			if(division_parts !== undefined){
				var blood_bags_id = "";
				if(this.form.state.option == "Unit"){
					blood_bags_id = this.form.unit.state.results.blood_bags_id;
				}else{
					blood_bags_id = this.form.criterials.state.blood_bags_id;
				}
				var error = '';

				if(division_parts.length === 0){
					notify.show("No se han seleccionado componentes para fraccionar", "error");
				}else{
					var multi = [] ;
					this.form.state.multigesta.map((m)=>{
						var index = division_parts.findIndex(obj => obj.donation_number === m);

						if(index !== -1){
							multi.push(m)
						}
					});


					var valid = true;
					if(multi.length > 0){
						console.log(division_parts)
						var msg = "<h3>Las unidades que intenta fraccionar cuentan con valor multigesta"+
		              			"¿Desea continuar con el fraccionamiento?<h3>"+
		              			"<table class='table' style='text-align:left'>"+
			                          "<thead>"+
			                            "<tr>"+
			                              "<th></th>"+
			                            "</tr>"+
			                          "</thead>"+
			                          "<tbody>";
			    		for(var i =0;i < multi.length;i++){
			                msg += "<tr>"+
			                          "<td>"+multi[i]+"</td>"+
			                        "</tr>";
			           	}
		              	msg += "</tbody></table>";
		              	swal({
		                  	title: "Unidades Multigesta",
		                	html:true,
			                text: msg,
			                type:"warning",
			                showCancelButton: true,
					        confirmButtonColor: '#DD6B55',
					        confirmButtonText: '¡Si, Continuar!',
					        cancelButtonText: '¡No, Cancelar!',
					        closeOnConfirm: true,
					        closeOnCancel: true,
			          	},  (isConfirm) =>{
			          		if(isConfirm){
								this.saving(division_parts, blood_bags_id);
			          		}
				        })
					}else{
						this.saving(division_parts, blood_bags_id);
					}

				}
			}
				
		 }else {
	    	notify.show('Error, Campos Incompletos','error');
        	//swal('¡El formulario no se puede enviar, tiene errores de validación!', '¡Los errores están marcados en rojo!', 'error');
	     }
	    }else {
			notify.show('Error, Fecha no válida','error');	    	
        }
	}

	saving(division_parts, blood_bags_id){
		var obj = {
			division_parts: division_parts,
			health_facilities_id: sessionStorage.getItem('health_facilities_id')
		};
		this.waiting_modal.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL+'division_program?blood_bags_id='+blood_bags_id+
			"&validation_date=YES", {
			method : 'POST',
			body   : JSON.stringify(obj),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.waiting_modal.handleClose();
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error!', result, 'error');
	          });
	        }})
		.then(response => {
			if(response !== undefined){
				if(response.length ===0){
					swal('¡Buen Trabajo!', "Proceso Terminado", 'success');
					
					this.form.setState({fractioning:[]});
					if(this.form.unit !== undefined){
						this.form.unit.setState({unit_number:""});
					}
					
				}else{//Unidades rechazadas
					var msg = "<table class='table' style='text-align:left'>"+
		                          "<thead>"+
		                            "<tr>"+
		                              "<th></th>"+
		                            "</tr>"+
		                          "</thead>"+
		                          "<tbody>";
		    		for(var i =0;i < response.length;i++){
		                msg += "<tr>"+
		                          "<td>"+response[i]+"</td>"+
		                        "</tr>";
		           	}
	              	msg += "</tbody></table><h3>¿Desea fraccionar y marcar unidades conflictivas como rechazadas?<h3>";
	              	swal({
	                  	title: "Unidades Rechazadas",
	                	html:true,
		                text: msg,
		                type:"warning",
		                showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true,
		          	}, function (isConfirm) {
				        if (isConfirm) {
				        	this.waiting_modal.handleShow('Guardando...');
							fetch(Config.default.apiGateway.URL+'division_program?blood_bags_id='+blood_bags_id+"&validation_date=NO", {
								method : 'POST',
								body   : JSON.stringify(obj),
								headers: new Headers({
									'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
									'Accept'		: 'application/json',
									'Content-Type'	: 'application/json'
								})
							})
							.then(res => {
								this.waiting_modal.handleClose();
						        if(res.ok){
						          return res.json();
						        }else{
						          res.text().then(function(result) {
						            swal('¡Error!', result, 'error');
						          });
						        }})
							.then(response => {
								swal('¡Buen Trabajo!', "Proceso Terminado", 'success');
								this.form.setState({fractioning:[]});
								if(this.form.unit !== undefined){
									this.form.unit.setState({unit_number:""});
								}
								
							});
				        }
				    }.bind(this));
				}
			}
		})
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.form.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });

	    return isFormValid;
	}

	onReturn(){
		this.props.history.push('/');
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.fractioning.MAIN')}
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_division"}  />
				
				<form noValidate>
					<FormFractioning {...this.props} onRef={ref => (this.form = ref)} />
					<Notifications />
				</form>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onReturn} style={{margin:12}}/>
		        	</div>
		        </div>

		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
} 

export default translate('translations')(Factioning);